import { Link, NavLink } from "react-router-dom"

import "./index.scss"
import LogoG from "../../assets/images/logo-g-s.png"
import LogoSubtitle from "../../assets/images/logo_sub.png"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faHome, faEye, faUser, faEnvelope } from "@fortawesome/free-solid-svg-icons"
import { faGithub } from "@fortawesome/free-brands-svg-icons"

const Sidebar = () => (
    <div className="nav-bar">
        <Link className="logo" to="/" aria-label="Greg Chui – home">
            <img src={LogoG} alt="" />
            <img className="sub-logo" src={LogoSubtitle} alt="" />
        </Link>
        <nav>
            <NavLink exact="true" activeclassname="active" to="/" aria-label="Home">
                <FontAwesomeIcon icon={faHome} />
            </NavLink>
            <NavLink exact="true" activeclassname="active" className="portfolio-link" to="/portfolio" aria-label="Portfolio">
                <FontAwesomeIcon icon={faEye} />
            </NavLink>
            <NavLink exact="true" activeclassname="active" className="about-link" to="/about" aria-label="About">
                <FontAwesomeIcon icon={faUser} />
            </NavLink>
            <NavLink exact="true" activeclassname="active" className="contact-link" to="/contact" aria-label="Contact">
                <FontAwesomeIcon icon={faEnvelope} />
            </NavLink>
        </nav>
        <ul>
            <li>
                <a 
                target="_blank"
                rel="noreferrer"
                href="https://github.com/gregchui"
                aria-label="GitHub">
                    <FontAwesomeIcon icon={faGithub} />
                </a>
            </li>
        </ul>
    </div>
)

export default Sidebar